import { Link } from "react-router-dom";
import { PROJECTS, CATEGORIES, wixImg } from "../data/projects";
import { useSEO } from "../lib/seo";

const Munkaink = () => {
  useSEO(
    "Referenciáink – Megvalósult építészeti terveink | New Idea Architect",
    "Lakóházak, társasházak és középületek – valós épületek, valós élethelyzetek. Nézd meg megvalósult építészeti projektjeinket.",
    "/munkaink"
  );
  return (
    <main className="flex flex-col gap-2.5 pb-2.5 pt-2.5">
      {/* Fekete fejléc box a világos háttéren */}
      <section className="px-2.5">
        <div className="rounded-2xl bg-[var(--card-dark)] p-8 sm:p-12">
          <h1 className="text-white heading-font font-bold text-5xl sm:text-6xl lg:text-7xl tracking-tight">Referenciáink</h1>
          <p className="text-white/85 text-base sm:text-lg mt-5 max-w-md leading-6">
            Valós épületek, valós élethelyzetek - tervek, a mindennapokból.
          </p>
          <div className="flex flex-wrap gap-3 mt-8">
            {CATEGORIES.map((c) => (
              <Link
                key={c.key}
                to={`/portfolio/${c.key}`}
                className="px-7 py-3.5 bg-white text-black text-sm font-bold rounded-md hover:bg-[var(--accent)] transition-colors duration-200"
              >
                {c.label}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {CATEGORIES.map((c) => (
        <section key={c.key} className="px-2.5">
          <div className="flex items-center justify-between px-2 mb-2.5 mt-5">
            <h2 className="text-[var(--heading-light)] heading-font font-bold text-2xl sm:text-3xl tracking-tight">{c.label}</h2>
            <Link to={`/portfolio/${c.key}`} className="text-[var(--link-light)] text-sm font-bold hover:underline underline-offset-4">
              Összes megtekintése
            </Link>
          </div>
          {/* Masonry elrendezés – a képek megtartják az eredeti arányukat, nincs levágás */}
          <div className="columns-2 md:columns-3 xl:columns-4 gap-2.5">
            {PROJECTS[c.key].map((p, i) => (
              <Link
                key={p.slug}
                to={`/portfolio/${c.key}/${p.slug}`}
                className="relative block mb-2.5 break-inside-avoid rounded-xl overflow-hidden group bg-[var(--tile-ph)]"
              >
                <img
                  src={wixImg(p.cover, 600)}
                  alt={p.name}
                  loading={i < 4 ? "eager" : "lazy"}
                  decoding="async"
                  className="w-full h-auto block"
                />
                <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-4 pt-12">
                  <span className="text-white font-bold text-sm sm:text-base">{p.name}</span>
                </span>
                <span className="absolute inset-0 rounded-xl ring-0 group-hover:ring-4 ring-[var(--accent)] ring-inset transition-shadow duration-200 pointer-events-none" />
              </Link>
            ))}
          </div>
        </section>
      ))}
    </main>
  );
};

export default Munkaink;
